"use client";
import React, { FC, PropsWithChildren } from 'react';
import {
  GlobalStateProvider,
  ShaApplicationProvider,
  StoredFilesProvider,
  useNextRouter,
} from '@shesha-io/reactjs';
import {
  CURRENT_APPOINTMENT_HEADER,
  EnterpriseApplicationPlugin,
} from "@shesha-io/enterprise";
import { WorkflowApplicationPlugin } from "@shesha-io/workflow";
import { ShaReportingPlugin } from "@shesha-io/reporting";
import { replaceAppIdInPath, urlContainsAppId } from '@/routing';
import { ExternalAuthenticationPlugin } from '@shesha-io/external-authentication';


export interface IAppProviderProps {
  backendUrl: string;
  positionAppointmentId?: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({
  children,
  backendUrl,
  positionAppointmentId,
}) => {
  const nextRouter = useNextRouter();

  const buildUrlWithAppId = (url: string): string => {
    return positionAppointmentId && !urlContainsAppId(url)
      ? replaceAppIdInPath(url, positionAppointmentId)
      : url;
  };

  return (
    <GlobalStateProvider>
      <ShaApplicationProvider
        backendUrl={backendUrl}
        router={nextRouter}
        noAuth={nextRouter.path?.includes("/no-auth")}
        buildHttpRequestHeaders={() => {
          return { [CURRENT_APPOINTMENT_HEADER]: positionAppointmentId };
        }}
        urlOverrideFunc={buildUrlWithAppId}
      >
        <EnterpriseApplicationPlugin>
          <ShaReportingPlugin>
            <WorkflowApplicationPlugin>
              <ExternalAuthenticationPlugin>
                <StoredFilesProvider
                  baseUrl={backendUrl}
                  ownerId={""}
                  ownerType={""}
                >
                  {children}
                </StoredFilesProvider>
              </ExternalAuthenticationPlugin>
            </WorkflowApplicationPlugin>
          </ShaReportingPlugin>
        </EnterpriseApplicationPlugin>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
